import React from 'react'
import CategoryBanner from '../CategoryBanner/CategoryBanner'

const PsolutionMarketplace = () => {
    const categoryImage = {}
  return (
    <CategoryBanner title ="Marketplace for partners to sell to their users" MarketCategoryType="08266b3d-e289-4246-8067-a8bca16b9112" categoryImage={categoryImage}/>
  )
}

export default PsolutionMarketplace